export * from './lib/interfaces/chips-autocomplete-form-field-config.interface';
export * from './lib/form-chips-autocomplete.module';
